import { render, staticRenderFns } from "./chat-pla.vue?vue&type=template&id=f3e82e5e&scoped=true"
import script from "./chat-pla.vue?vue&type=script&lang=js"
export * from "./chat-pla.vue?vue&type=script&lang=js"
import style0 from "./chat-pla.vue?vue&type=style&index=0&id=f3e82e5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e82e5e",
  null
  
)

export default component.exports